import { INameValuePair } from './interfaces';

export default [     
    { value: undefined, name: 'All' },
    { value: 1, name: 'Point Accrual' },
    { value: 2, name: 'Point Redemption' },
    { value: 3, name: 'Manual Point Adjustment' },
] as Array<INameValuePair>;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/data/frequent-parker-activity-types.ts